import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrLabelComponent } from './pr-label.component';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrTooltipIconModule } from '../pr-tooltip-icon/pr-tooltip-icon.module';

@NgModule({
  declarations: [PrLabelComponent],
  imports: [CommonModule, PrIconModule, PrTooltipIconModule],
  exports: [PrLabelComponent],
})
export class PrLabelModule {}
